export enum TriggerType {
  mailhook = 'mailhook',
  webhook = 'webhook'
}
